<div *ngIf="usePopover">
	<mat-form-field
		#popoverTrigger="mtxPopoverTrigger"
		(click)="$event.stopPropagation()"
		[mtxPopoverTriggerFor]="carrierPopover"
		class="{{ customFormFieldClass }}"
		floatLabel="never"
		fxFlex
		mtxPopoverTriggerOn="click"
	>
		<mat-label [ngClass]="{ 'primary-text': placeholder !== 'Carrier' }">
			{{ placeholder }}
		</mat-label>
		<input matInput readonly="true" />
		<mat-icon *ngIf="renderDownArrowIcon()" class="vertical-align-middle" matSuffix>
			keyboard_arrow_down
		</mat-icon>
		<mat-icon
			(click)="$event.stopPropagation(); removeSelectedCarrier()"
			*ngIf="renderCloseArrowIcon()"
			class="vertical-align-middle danger-text cursor-pointer"
			matSuffix
		>
			close
		</mat-icon>
	</mat-form-field>

	<mtx-popover #carrierPopover="mtxPopover" [closeOnPanelClick]="false">
		<mat-card class="p-0 primary-border">
			<mat-card-content class="carriers-dropdown font-size-14 p-b-2">
				<div class="padding-0-5" fxLayout="row">
					<mat-form-field fxFlex>
						<input
							(input)="inputChanged($event.target.value)"
							[(ngModel)]="searchText"
							autocomplete="off"
							matInput
							placeholder="Type to filter"
						/>
					</mat-form-field>
				</div>
				<div *ngIf="isLoadingCarriersList" class="padding-0-5" fxLayout="row">
					<div fxFlex fxLayoutAlign="center center">
						<mat-spinner [diameter]="11"></mat-spinner>
					</div>
				</div>
				<div
					(click)="setSelectedCarrier(carrier)"
					*ngFor="let carrier of carriersList"
					class="padding-0-5 carrier-row cursor-pointer"
					fxLayout="row"
				>
					<div class="primary-text" fxFlex fxLayoutAlign="start center">
						{{ GET_CARRIER_BUSINESS_NAME(carrier.businessName, carrier.doingBusinessAs) }}
					</div>
				</div>

				<div
					*ngIf="!isLoadingCarriersList && searchText.length > 0 && carriersList.length === 0"
					class="padding-0-5 carrier-row"
				>
					<div class="link" fxFlex fxLayoutAlign="center center">No Carriers Found</div>
				</div>
			</mat-card-content>
		</mat-card>
	</mtx-popover>
</div>

<div *ngIf="useAutoComplete">
	<mat-form-field class="full-width" floatLabel="never">
		<input
			#carrierInput
			(input)="inputChanged($event.target.value)"
			[(ngModel)]="searchText"
			[matAutocomplete]="auto"
			[disabled]="disabled"
			matInput
			[placeholder]="placeholder"
		/>

		<mat-autocomplete
			#auto="matAutocomplete"
			(optionSelected)="selected($event)"
			[displayWith]="displayFn"
		>
			<mat-option *ngIf="isLoadingCarriersList" fxLayoutAlign="center center">
				<mat-spinner [diameter]="30"></mat-spinner>
			</mat-option>

			<ng-container *ngIf="!isLoadingCarriersList">
				<mat-option *ngFor="let carrier of carriersList" [value]="carrier">
					{{ GET_CARRIER_BUSINESS_NAME(carrier.businessName, carrier.doingBusinessAs) }}
				</mat-option>
			</ng-container>
		</mat-autocomplete>
	</mat-form-field>
</div>

<div *ngIf="useMultiSelect">
	<mat-form-field class="full-width" floatLabel="never">
		<input
			#carrierInput
			(input)="inputChanged($event.target.value)"
			[(ngModel)]="searchText"
			[matAutocomplete]="auto"
			[disabled]="disabled"
			matInput
			[placeholder]="placeholder"
		/>

		<span
			*ngIf="selectedCarriersList.length"
			matSuffix
			fxFlex
			fxLayoutAlign="space-between center"
			#popoverTrigger="mtxPopoverTrigger"
			mtxPopoverTriggerOn="click"
			(click)="$event.stopPropagation()"
			[mtxPopoverTriggerFor]="selectedCarriersPopover"
			class="font-size-12 input_carriers_list m-r-0-5 cursor-pointer"
		>
			+{{ selectedCarriersList.length }}
			<mat-icon class="input_menu_filter_icon">arrow_drop_down</mat-icon>
		</span>

		<mat-autocomplete
			#auto="matAutocomplete"
			(optionSelected)="selected($event)"
			[displayWith]="displayFn"
		>
			<mat-option *ngIf="isLoadingCarriersList" fxLayoutAlign="center center">
				<mat-spinner [diameter]="30"></mat-spinner>
			</mat-option>

			<ng-container *ngIf="!isLoadingCarriersList">
				<mat-option *ngFor="let carrier of carriersList" [value]="carrier" [disabled]="true">
					<div fxLayoutAlign="space-between center">
						<span class="ellipsis">
							{{ GET_CARRIER_BUSINESS_NAME(carrier.businessName, carrier.doingBusinessAs) }}
						</span>
						<span
							class="link cursor-pointer"
							(click)="removeCarrierSelection(carrier)"
							*ngIf="isCarrierSelected(carrier); else addCarrier"
						>
							Remove
						</span>
						<ng-template #addCarrier>
							<span class="link cursor-pointer" (click)="selected({ option: { value: carrier } })">
								Add
							</span>
						</ng-template>
					</div>
				</mat-option>
			</ng-container>
		</mat-autocomplete>
	</mat-form-field>

	<mtx-popover #selectedCarriersPopover="mtxPopover" [closeOnPanelClick]="false">
		<mat-card class="p-0 primary-border">
			<mat-card-content class="selected_carriers_list_dropdown font-size-14 p-b-2">
				<div class="padding-0-5">
					<mat-form-field fxFlex>
						<input
							[(ngModel)]="filterSelectedCarrierslistText"
							autocomplete="off"
							matInput
							placeholder="Type to filter"
						/>
					</mat-form-field>
				</div>
				<div
					class="padding-0-5"
					fxLayout="row"
					*ngFor="
						let carrier of selectedCarriersList
							| search: 'businessName' : filterSelectedCarrierslistText
					"
				>
					<div class="full-width" fxLayoutAlign="space-between center" fxLayoutGap="4px">
						<div fxFlex class="ellipsis business_name_container">
							{{ GET_CARRIER_BUSINESS_NAME(carrier.businessName, carrier.doingBusinessAs) }}
						</div>
						<div fxFlex="20" class="link font-size-12" fxLayoutAlign="end center">
							<span (click)="removeCarrierSelection(carrier)"> Remove </span>
						</div>
					</div>
				</div>

				<div
					*ngIf="filterSelectedCarrierslistText?.length > 0 && selectedCarriersList?.length === 0"
					class="padding-0-5 customer-row"
				>
					<div fxFlex fxLayoutAlign="center center">No Carrier found.</div>
				</div>
			</mat-card-content>
		</mat-card>
	</mtx-popover>
</div>
